import { render, staticRenderFns } from "./CandidateCreateFormAdditionalInput.vue?vue&type=template&id=212fd6bf&scoped=true&"
import script from "./CandidateCreateFormAdditionalInput.vue?vue&type=script&lang=js&"
export * from "./CandidateCreateFormAdditionalInput.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCreateFormAdditionalInput.vue?vue&type=style&index=0&id=212fd6bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212fd6bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
